import { Col, Row, Typography } from 'antd';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { TwoLinesSeparator } from '../../../components/layout/layoutElements';
import { useQuoteStyles } from '../../../styles/quote.styles';
import DateTimeDisplay from './DateTimeDisplay';
import { DateFormatMedium } from '../../../utils/dateFormatting';
import { cssVariables } from '../../../styles/cssVariables';
import { ToBeDefined } from './components/NoValue';
import { useShipmentDetailsStyles } from './ShipmentDetails.styles';
import { useQuoteContentSmallStyles } from './QuoteContentSmall.styles';

export default function ShipmentDetails({
  title,
  subtitle,
  dateTime,
  children,
  span = 6,
}) {
  const { styles: sharedStyles } = useQuoteStyles();
  const { styles } = useShipmentDetailsStyles();
  return (
    <Col span={span}>
      <div className={classNames('ShipmentDetails', styles.shipmentDetails)}>
        <TwoLinesSeparator
          style={{
            marginTop: cssVariables.spaceLg,
            marginBottom: cssVariables.spaceSm,
          }}
        />
        <Typography.Title
          level={3}
          className={classNames(
            'text-uppercase',
            sharedStyles.shipmentInfoTitle
          )}
        >
          <FormattedMessage id={title} />
        </Typography.Title>
        <TwoLinesSeparator />
        <Typography.Title
          level={3}
          className={classNames('text-uppercase', sharedStyles.shipmentStatus)}
        >
          <FormattedMessage id={subtitle} />
          <div className="text-highlight">
            {dateTime ? (
              <DateTimeDisplay
                dateTime={dateTime}
                formatComponent={DateFormatMedium}
              />
            ) : (
              <ToBeDefined />
            )}
          </div>
        </Typography.Title>
        {children}
      </div>
    </Col>
  );
}

export function ShipmentDetailsSmall({
  title,
  subtitle,
  dateTime,
  children,
  className,
}) {
  const { styles } = useShipmentDetailsStyles();
  return (
    <Col span={12} className={className}>
      <div className={classNames('ShipmentDetails', styles.shipmentDetails)}>
        <div className="text-uppercase ShipmentDetailsTitle">
          <FormattedMessage id={title} />
        </div>

        <div
          className="text-uppercase"
          style={{ fontSize: 12, fontFamily: 'Roboto Condensed' }}
        >
          <FormattedMessage id={subtitle} />{' '}
          <span className="text-highlight" style={{ fontWeight: '700' }}>
            {dateTime ? (
              <DateTimeDisplay
                onlyDate
                dateTime={dateTime}
                formatComponent={DateFormatMedium}
              />
            ) : (
              <ToBeDefined />
            )}
          </span>
        </div>
        {children}
      </div>
    </Col>
  );
}

export function ShipmentDetailsLg({ title, children, className }) {
  const { styles: sharedStyles } = useQuoteStyles();
  const { styles } = useQuoteContentSmallStyles();
  return (
    <Col span={12} className={className}>
      <Row>
        <Col span={24}>
          <TwoLinesSeparator className="full-width-separator" />
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <div
            className={classNames(
              'text-uppercase',
              sharedStyles.shipmentInfoTitle,
              styles.shipmentDetailsLgTitle
            )}
          >
            <FormattedMessage id={title} />
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <TwoLinesSeparator className="full-width-separator" />
        </Col>
      </Row>
      {children}
    </Col>
  );
}
